import { buildMode, BuildMode } from "@/services/buildMode";

// Google Ads conversions are sent straight through gtag() rather than through a GTM tag — the GTM audit
// (ColectioOrg/app.colectio.com#1457) found no tag consuming the dataLayer ecommerce events, so the app reports the
// conversions itself. Conversion labels come from MKT.
const CONVERSION_ID = "AW-16714161893";

enum Conversion {
  RegistrationDone = "FxbOCIGTq_MZEOW996E-",
  Purchase = "T9zwCNnf0ZYdEOW996E-",
}

type ConversionParams = {
  value: number;
  currency: string;
  transaction_id: string; // Google Ads deduplicates repeated sends of the same conversion by this value.
};

const isTrackingAllowed = (): boolean => {
  const allowedModes = [BuildMode.Production];
  return allowedModes.includes(buildMode);
};

const trackConversion = (conversion: Conversion, params?: ConversionParams): void => {
  if (!isTrackingAllowed()) {
    return;
  }
  if (typeof window.gtag !== "function") {
    console.warn("gtag() not found — Google Ads conversion not sent.");
    return;
  }
  window.gtag("event", "conversion", { send_to: `${CONVERSION_ID}/${conversion}`, ...params });
};

export default {
  trackConversion,
  Conversion,
};
